const usePhotoSubmission = ({
  photoFile,
  photoPreview,
  typing,
  addUserMessage,
  advanceQuestion,
  setPhotoFile,
}) => {
  const sendPhoto = async () => {
    if (!photoFile || !photoPreview || typing) return

    addUserMessage({
      text: '',
      photoUrl: photoPreview,
    })

    await advanceQuestion(null, photoPreview)

    setPhotoFile(null)
  }

  return {
    sendPhoto,
  }
}

export default usePhotoSubmission